import {
    deleteEventById,
    duplicateEventById,
    editEvent,
    enableEventConnection,
   // getAllHosts,
    getEventById,
    getHostById,
    getHostEventHistory,
    getHostGallery,
    getHostReviews,
    updateEventOnlineLink,
    updateEventStatus,
    updateHost
} from 'apis/events';
import { DropDown, InputField, MainNavbar, MainSidebar } from 'components';
import PublishedEventCard from 'components/NEW/cards/publishedEvents';
import { EVENTS, USERS } from 'common/routes';
import moment from 'moment';
import React, { lazy, Suspense, useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom';
import { decodeFromBase64, encodeToBase64 } from 'utils/encodeAndDecode';

const topTabs = ['Basic Details', 'Events', 'Reviews', 'Gallery'];
const eventTabs = ['published', 'draft', 'completed'];
const statusOptions = [
    { label: 'Active', value: true },
    { label: 'Inactive', value: false },
];
const defaultLimit = 10;
const EventLink = lazy(() => import('components/NEW/popups/eventLink'));

const emptyPagination = {
    currentPage: 1,
    nextPage: null,
    prevPage: null,
    total: 0,
};

const defaultFormState = {
    name: '',
    photo: null,
    bio: '',
    createdBy: '',
    insta_link: '',
    facebook_link: '',
    website: '',
    interaction_type: '',
    focus: '',
    category: '',
    secondary_tags: '',
    vibe: '',
    for_whom: '',
    bank_name: '',
    account_number: '',
    ifsc_code: '',
    status: true,
};

const arrayToCsv = (value) => Array.isArray(value) ? value.join(', ') : value || '';

const csvToArray = (value) => String(value || '')
    .split(',')
    .map((item) => item.trim())
    .filter(Boolean);

const buildFormState = (host) => ({
    name: host?.name || '',
    photo: host?.photo || null,
    bio: host?.bio || '',
    createdBy: host?.createdBy || '',
    insta_link: host?.insta_link || '',
    facebook_link: host?.facebook_link || '',
    website: host?.website || '',
    interaction_type: host?.interaction_type || '',
    focus: host?.focus || '',
    category: host?.category || '',
    secondary_tags: arrayToCsv(host?.secondary_tags),
    vibe: arrayToCsv(host?.vibe),
    for_whom: host?.for_whom || '',
    bank_name: host?.bank_name || '',
    account_number: host?.account_number || '',
    ifsc_code: host?.ifsc_code || '',
    status: host?.status ?? true,
});

const getPaginationFromResponse = (response) => {
    const pagination = response?.pagination || response?.data?.pagination || response?.data?.pageInfo || {};
    return {
        currentPage: pagination?.current_page || pagination?.page || 1,
        nextPage: pagination?.next_page || pagination?.nextPage || null,
        prevPage: pagination?.previous_page || pagination?.prevPage || null,
        total: pagination?.total || pagination?.total_count || pagination?.count || 0,
    };
};

const getListFromResponse = (response) => {
    const payload = response?.data;
    if (Array.isArray(payload)) return payload;
    if (Array.isArray(payload?.data)) return payload.data;
    if (Array.isArray(payload?.events)) return payload.events;
    if (Array.isArray(payload?.reviews)) return payload.reviews;
    if (Array.isArray(payload?.gallery)) return payload.gallery;
    if (Array.isArray(payload?.items)) return payload.items;
    if (Array.isArray(payload?.docs)) return payload.docs;
    if (Array.isArray(payload?.images)) return payload.images;
    return [];
};

const normaliseGalleryItems = (items) => items.map((item, index) => {
    if (typeof item === 'string') {
        return { id: `${item}-${index}`, image: item };
    }

    return {
        id: item?.id || item?._id || `${index}`,
        image: item?.image || item?.url || item?.photo || item?.src || '',
        caption: item?.caption || item?.title || '',
    };
}).filter((item) => item.image);

const extractEntityId = (value) => {
    if (Array.isArray(value)) {
        return value.map((item) => item?._id || item?.id || item).filter(Boolean);
    }

    if (value && typeof value === 'object') {
        return value?._id || value?.id || null;
    }

    return value ?? null;
};

function Pagination({ pageNation, onPrev, onNext }) {
    if (!pageNation?.prevPage && !pageNation?.nextPage) {
        return null;
    }

    return (
        <div className="mt-6 flex items-center justify-center gap-4">
            {pageNation?.prevPage && (
                <button type="button" onClick={onPrev} className="rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700">
                    Prev
                </button>
            )}
            {pageNation?.nextPage && (
                <button type="button" onClick={onNext} className="rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700">
                    Next
                </button>
            )}
        </div>
    );
}

function ReviewCard({ review, index }) {
    const author = review?.user?.name || review?.name || `Reviewer ${index + 1}`;
    const rating = review?.rating ?? review?.stars ?? 0;
    const comment = review?.comment || review?.review || review?.message || 'No review comment available.';

    return (
        <div className="rounded-lg border border-gray-200 bg-white p-4 shadow-sm">
            <div className="flex items-center justify-between gap-3">
                <h3 className="text-base font-semibold text-black">{author}</h3>
                <span className="rounded-full bg-yellow-50 px-3 py-1 text-sm font-medium text-yellow-700">
                    {rating}/5
                </span>
            </div>
            <p className="mt-3 text-sm leading-6 text-gray-600">{comment}</p>
        </div>
    );
}

function Index() {
    const { id } = useParams();
    const decodedId = decodeFromBase64(id);
    const fileInputRef = useRef(null);

    const [currentTab, setCurrentTab] = useState('Basic Details');
    const [currentEventTab, setCurrentEventTab] = useState('published');
    const [host, setHost] = useState(null);
    const [formData, setFormData] = useState(defaultFormState);
    const [photoPreview, setPhotoPreview] = useState('');
    const [events, setEvents] = useState([]);
    const [eventsPagination, setEventsPagination] = useState(emptyPagination);
    const [duplicate, setDuplicate] = useState(false);
    const [duplicateEventId, setDuplicateEventId] = useState(null);
    const [eventLink, setEventLink] = useState({
        visibility: false,
        evetnId: null,
        link: null,
    });
    const [reviews, setReviews] = useState([]);
    const [reviewsPagination, setReviewsPagination] = useState(emptyPagination);
    const [gallery, setGallery] = useState([]);
    const [galleryPagination, setGalleryPagination] = useState(emptyPagination);
    const [loading, setLoading] = useState(true);
    const [eventsLoading, setEventsLoading] = useState(false);
    const [reviewsLoading, setReviewsLoading] = useState(false);
    const [galleryLoading, setGalleryLoading] = useState(false);
    const [saving, setSaving] = useState(false);

    const updateField = (key, value) => {
        setFormData((prev) => ({ ...prev, [key]: value }));
    };

    const fetchHost = async () => {
        const res = await getHostById(decodedId);
        if (!res?.success) {
            return null;
        }

        if (Array.isArray(res?.data)) {
            return res.data || null;
        }

        return res?.data || null;
    };

    const fetchHostEvents = async (page = 1, type = currentEventTab) => {
        setEventsLoading(true);
        try {
            const res = await getHostEventHistory(decodedId, type, page, defaultLimit);
            setEvents(getListFromResponse(res));
            setEventsPagination(getPaginationFromResponse(res));
        } finally {
            setEventsLoading(false);
        }
    };

    const handleConnection = async (eventId) => {
        const res = await enableEventConnection(eventId);
        if (res?.success) {
            toast.success('Updated Event Connection');
            fetchHostEvents(eventsPagination.currentPage || 1, currentEventTab);
        }
    };

    const handleViewParticipant = (eventId) => {
        const url = `${EVENTS.VIEW_EVENT_PARTICIPANT}/${encodeToBase64(eventId)}`;
        window.open(url, '_blank', 'noopener,noreferrer');
    };

    const handleEdit = (eventId) => {
        const url = `${EVENTS.CREATE_AND_EDIT_EVENT_BASIC}/${encodeToBase64('edit')}/${encodeToBase64(eventId)}`;
        window.open(url, '_blank', 'noopener,noreferrer');
    };

    const handleDuplicate = (eventId) => {
        setDuplicate(true);
        setDuplicateEventId(eventId);
    };

    const duplicateEventApi = async () => {
        const res = await duplicateEventById(duplicateEventId);
        if (res?.success) {
            toast.success('Event Duplicated Successfully...');
        }
        fetchHostEvents(eventsPagination.currentPage || 1, currentEventTab);
        setDuplicate(false);
        setDuplicateEventId(null);
    };

    const handleView = (slug, comment) => {
        const url = `${EVENTS.VIEW_EVENT}/${encodeToBase64(slug)}/${comment}`;
        window.open(url, '_blank', 'noopener,noreferrer');
    };

    const handleDelete = async (eventId) => {
        const res = await deleteEventById(eventId);
        if (res?.success) {
            toast.success('Event Deleted Successfully...');
        }
        fetchHostEvents(eventsPagination.currentPage || 1, currentEventTab);
    };

    const handleUpdateHostEventOnlineLink = async (eventId, link) => {
        const res = await updateEventOnlineLink(eventId, { online_event_link: link });
        if (res?.success) {
            setEventLink({ visibility: false, evetnId: null, link: null });
            toast.success('Event Online Link Updated Successfully...');
        }
        fetchHostEvents(eventsPagination.currentPage || 1, currentEventTab);
    };

    const handleUpdateHostEventStatus = async (eventId, value) => {
        const res = await updateEventStatus(eventId, value);
        if (res?.success) {
            toast.success('Event Status Updated Successfully...');
        }
        fetchHostEvents(eventsPagination.currentPage || 1, currentEventTab);
    };

    const handleUpdateHostEventPaidStatus = async (eventId, value) => {
        try {
            const eventResponse = await getEventById(eventId);
            const eventData = eventResponse?.data;

            if (!eventResponse?.success || !eventData) {
                toast.error('Unable to load event details.');
                return;
            }

            const other = { ...eventData };
            delete other.enable_connections;
            delete other.sold_out;
            delete other.current_step;
            delete other.createdAt;
            delete other.updatedAt;
            delete other.publish_status;
            delete other.id;

            const payload = {
                ...other,
                host: extractEntityId(eventData?.host),
                co_hosts: extractEntityId(eventData?.co_hosts),
                categories: extractEntityId(eventData?.categories),
                tags: extractEntityId(eventData?.tags),
                location: extractEntityId(eventData?.location),
                isFree: !value,
                paid: value,
            };

            const res = await editEvent(eventData?.id || eventId, payload);
            if (res?.success) {
                toast.success(`Event marked as ${value ? 'paid' : 'unpaid'}.`);
            }
        } catch (error) {
            toast.error('Unable to update event paid status.');
        }

        fetchHostEvents(eventsPagination.currentPage || 1, currentEventTab);
    };

    const handleEligibleParticipants = (eventId) => {
        const url = `${EVENTS.ELIGIBLE_PARTICIPANTS}/${encodeToBase64(eventId)}`;
        window.open(url, '_blank', 'noopener,noreferrer');
    };

    const handleAdminClick = () => {
        const adminId = host?.admin?.id || host?.createdBy;
        if (!adminId) return;

        const url = USERS.EDIT_USER_DETAILS.replace(':id', encodeToBase64(adminId));
        window.open(url, '_blank', 'noopener,noreferrer');
    };

    const fetchHostReviewsData = async (page = 1) => {
        setReviewsLoading(true);
        try {
            const res = await getHostReviews(decodedId, page, defaultLimit);
            setReviews(getListFromResponse(res));
            setReviewsPagination(getPaginationFromResponse(res));
        } finally {
            setReviewsLoading(false);
        }
    };

    const fetchHostGalleryData = async (page = 1) => {
        setGalleryLoading(true);
        try {
            const res = await getHostGallery(decodedId, page, defaultLimit);
            setGallery(normaliseGalleryItems(getListFromResponse(res)));
            setGalleryPagination(getPaginationFromResponse(res));
        } finally {
            setGalleryLoading(false);
        }
    };

    const fetchPageData = async () => {
        setLoading(true);
        try {
            const hostData = await fetchHost();
            if (!hostData) {
                toast.error('Host details not found.');
                return;
            }

            setHost(hostData);
            setFormData(buildFormState(hostData));
            setPhotoPreview(hostData?.photo || '');
            await fetchHostEvents(1, currentEventTab);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (decodedId) {
            fetchPageData();
        }
    }, [decodedId]);

    useEffect(() => {
        if (decodedId && currentTab === 'Events') {
            fetchHostEvents(1, currentEventTab);
        }
    }, [currentEventTab]);

    useEffect(() => {
        if (decodedId && currentTab === 'Reviews' && reviews.length === 0) {
            fetchHostReviewsData(1);
        }
        if (decodedId && currentTab === 'Gallery' && gallery.length === 0) {
            fetchHostGalleryData(1);
        }
    }, [currentTab, decodedId]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [currentTab, currentEventTab]);

    const openFilePicker = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    const handleImageChange = (event) => {
        const file = event.target.files?.[0];
        if (!file || file.type.substr(0, 5) !== 'image') {
            toast.error('Please choose a valid image file.');
            return;
        }

        const reader = new FileReader();
        reader.onloadend = () => {
            updateField('photo', file);
            setPhotoPreview(reader.result);
        };
        reader.readAsDataURL(file);
    };

    const handleSave = async () => {
        setSaving(true);
        const payload = {
            ...formData,
            secondary_tags: csvToArray(formData.secondary_tags),
            vibe: csvToArray(formData.vibe),
        };

        try {
            const res = await updateHost(decodedId, payload);
            if (res?.success) {
                toast.success('Host updated successfully.');
                const refreshedHost = await fetchHost();
                if (refreshedHost) {
                    setHost(refreshedHost);
                    setFormData(buildFormState(refreshedHost));
                    setPhotoPreview(refreshedHost?.photo || '');
                }
            }
        } finally {
            setSaving(false);
        }
    };

    const metricCards = [
        { label: 'Followers', value: host?.followers_count ?? 0 },
        { label: 'Total Events', value: host?.total_events ?? host?.totalEvents ?? 0 },
        { label: 'Published Events', value: host?.total_published_events ?? 0 },
        { label: 'Completed Events', value: host?.total_completed_events ?? 0 },
        { label: 'Average Rating', value: host?.average_rating ?? 0 },
    ];

    const renderBasicDetails = () => {
        const admin = host?.admin;
        const fields = [
            { key: 'name', label: 'Host Name' },
            { key: 'bio', label: 'Bio', textArea: true },
            { key: 'createdBy', label: 'Created By', readOnly: true },
            { key: 'insta_link', label: 'Instagram Link' },
            { key: 'facebook_link', label: 'Facebook Link' },
            { key: 'website', label: 'Website' },
            { key: 'interaction_type', label: 'Interaction Type' },
            { key: 'focus', label: 'Focus' },
            { key: 'category', label: 'Category' },
            { key: 'secondary_tags', label: 'Secondary Tags' },
            { key: 'vibe', label: 'Vibe' },
            { key: 'for_whom', label: 'For Whom' },
            { key: 'bank_name', label: 'Bank Name' },
            { key: 'account_number', label: 'Account Number' },
            { key: 'ifsc_code', label: 'IFSC Code' },
        ];

        return (
            <div className="grid gap-8 xl:grid-cols-[300px_minmax(0,1fr)]">
                <div className="rounded-xl bg-white p-5 shadow-sm">
                    <img
                        src={photoPreview || 'https://via.placeholder.com/400x400?text=Host'}
                        alt={formData.name || 'Host'}
                        className="h-64 w-full rounded-lg object-cover"
                    />
                    <button
                        type="button"
                        onClick={openFilePicker}
                        className="mt-4 w-full rounded-lg bg-brandRed px-4 py-3 text-sm font-semibold text-white"
                    >
                        Change Photo
                    </button>
                    <input
                        ref={fileInputRef}
                        type="file"
                        accept="image/*"
                        className="hidden"
                        onChange={handleImageChange}
                    />

                    {(admin?.id || host?.createdBy) && (
                        <button
                            type="button"
                            onClick={handleAdminClick}
                            className="mt-5 w-full rounded-xl border border-gray-200 bg-white p-4 text-left transition-colors hover:border-brandRed hover:bg-red-50"
                        >
                            <p className="mb-3 text-sm font-semibold text-black">Host</p>
                            <div className="flex items-center gap-3">
                                <img
                                    src={admin?.image || 'https://via.placeholder.com/120x120?text=Host'}
                                    alt={admin?.name || 'Host'}
                                    className="h-14 w-14 rounded-full object-cover"
                                />
                                <div className="min-w-0 flex-1">
                                    <p className="truncate text-base font-semibold text-black">
                                        {admin?.name || 'View host user'}
                                    </p>
                                    <p className="truncate text-sm text-gray-500">
                                        {admin?.profession || admin?.id || host?.createdBy}
                                    </p>
                                </div>
                                <span className="text-lg text-gray-400">{'>'}</span>
                            </div>
                        </button>
                    )}
                </div>

                <div className="rounded-xl bg-white p-6 shadow-sm">
                    <div className="mb-6 grid gap-4 md:grid-cols-2 xl:grid-cols-5">
                        {metricCards.map((item) => (
                            <div key={item.label} className="rounded-lg border border-gray-200 p-4">
                                <p className="text-sm text-gray-500">{item.label}</p>
                                <p className="mt-2 text-2xl font-semibold text-black">{item.value}</p>
                            </div>
                        ))}
                    </div>

                    <div className="grid gap-5 md:grid-cols-2">
                        {fields.map((field) => (
                            <div key={field.key} className={field.textArea ? 'md:col-span-2' : ''}>
                                <p className="mb-2 text-sm font-semibold text-black">{field.label}</p>
                                <InputField
                                    value={formData[field.key]}
                                    onChange={(value) => updateField(field.key, value)}
                                    type="text"
                                    readOnly={field.readOnly}
                                    textArea={field.textArea}
                                    className={field.textArea ? 'h-32' : ''}
                                />
                            </div>
                        ))}

                        <div>
                            <p className="mb-2 text-sm font-semibold text-black">Status</p>
                            <div className="h-[56px]">
                                <DropDown
                                    selectedValue={formData.status}
                                    options={statusOptions}
                                    handleOnChange={(value) => updateField('status', value)}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="mt-8 flex justify-end">
                        <button
                            type="button"
                            onClick={handleSave}
                            disabled={saving}
                            className="rounded-lg bg-brandRed px-6 py-3 text-sm font-semibold text-white disabled:cursor-not-allowed disabled:opacity-70"
                        >
                            {saving ? 'Saving...' : 'Save Changes'}
                        </button>
                    </div>
                </div>
            </div>
        );
    };

    const renderEvents = () => (
        <div className="rounded-xl bg-white p-6 shadow-sm">
            <div className="mb-6 flex gap-3">
                {eventTabs.map((tab) => (
                    <button
                        key={tab}
                        type="button"
                        onClick={() => setCurrentEventTab(tab)}
                        className={`rounded-lg px-5 py-2 text-sm font-semibold capitalize ${
                            currentEventTab === tab ? 'bg-brandRed text-white' : 'bg-gray-100 text-gray-700'
                        }`}
                    >
                        {tab}
                    </button>
                ))}
            </div>

            {eventsLoading ? (
                <div className="py-16 text-center text-gray-500">Loading events...</div>
            ) : events.length ? (
                <>
                    <div className="flex flex-wrap gap-4">
                        {events.map((event) => (
                            <PublishedEventCard
                                key={event?.id || event?._id}
                                eventImg={event?.image}
                                totalBookings={event?.total_bookings}
                                status={event?.publish_status}
                                connection={event?.enable_connections}
                                eventName={event?.title}
                                eventCategory={event?.categories}
                                eventPrice={event?.price}
                                eventTime={event?.start_time}
                                eventDate={event?.start_date ? moment(event?.start_date).format('YYYY-MM-DD') : 'N/A'}
                                totalSlots={event?.total_slots}
                                eventType={event?.mode}
                                totalPrebooked={event?.total_prebookings}
                                location={event?.location}
                                totalComments={event?.total_comments}
                                totalParticipants={event?.total_bookings}
                                prebookingEnabled={event?.prebooking_enabled}
                                paid={event?.paid ?? !event?.isFree}
                                handleDelete={() => handleDelete(event?.id)}
                                handleDuplicate={() => handleDuplicate(event?.id)}
                                handleEdit={() => handleEdit(event?.id)}
                                handleViewEventParticipants={() => handleViewParticipant(event?.id)}
                                handleViewEventComments={() => handleView(event?.slug, true)}
                                handleViewEvent={() => handleView(event?.slug, false)}
                                handleUpdateEventConnectionStatus={() => handleConnection(event?.id)}
                                handleUpdateEventStatus={(value) => handleUpdateHostEventStatus(event?.id, value)}
                                handleUpdateEventPaidStatus={() => handleUpdateHostEventPaidStatus(event?.id, !(event?.paid ?? !event?.isFree))}
                                updateEventLink={() => setEventLink({ visibility: true, link: event?.online_event_link, evetnId: event?.id })}
                                handleEligibleParticipants={() => handleEligibleParticipants(event?.id)}
                                showConnectionToggle={currentEventTab === 'published' || currentEventTab === 'completed'}
                                showPaidToggle={currentEventTab === 'completed'}
                                showParticipantsButton={currentEventTab === 'published' || currentEventTab === 'completed'}
                                showCommentsButton={currentEventTab === 'published' || currentEventTab === 'completed'}
                                showEligibleParticipantsButton={true}
                                showDeleteButton={true}
                                showDuplicateButton={true}
                                showEditButton={true}
                                showViewButton={currentEventTab === 'draft'}
                            />
                        ))}
                    </div>
                    <Pagination
                        pageNation={eventsPagination}
                        onPrev={() => fetchHostEvents(eventsPagination.prevPage, currentEventTab)}
                        onNext={() => fetchHostEvents(eventsPagination.nextPage, currentEventTab)}
                    />
                </>
            ) : (
                <div className="rounded-lg border border-dashed border-gray-300 px-6 py-16 text-center text-gray-500">
                    No {currentEventTab} events found for this host.
                </div>
            )}
        </div>
    );

    const renderReviews = () => (
        <div className="rounded-xl bg-white p-6 shadow-sm">
            <div className="mb-6 flex items-center justify-between">
                <div>
                    <h2 className="text-xl font-semibold text-black">Host Reviews</h2>
                    <p className="mt-1 text-sm text-gray-500">Average rating: {host?.average_rating ?? 0}/5</p>
                </div>
                <div className="rounded-lg bg-yellow-50 px-4 py-3 text-sm font-medium text-yellow-700">
                    Total Reviews: {reviewsPagination.total || reviews.length}
                </div>
            </div>

            {reviewsLoading ? (
                <div className="py-16 text-center text-gray-500">Loading reviews...</div>
            ) : reviews.length ? (
                <>
                    <div className="grid gap-5 lg:grid-cols-2">
                        {reviews.map((review, index) => (
                            <ReviewCard key={review?.id || review?._id || index} review={review} index={index} />
                        ))}
                    </div>
                    <Pagination
                        pageNation={reviewsPagination}
                        onPrev={() => fetchHostReviewsData(reviewsPagination.prevPage)}
                        onNext={() => fetchHostReviewsData(reviewsPagination.nextPage)}
                    />
                </>
            ) : (
                <div className="rounded-lg border border-dashed border-gray-300 px-6 py-16 text-center text-gray-500">
                    No reviews found for this host.
                </div>
            )}
        </div>
    );

    const renderGallery = () => (
        <div className="rounded-xl bg-white p-6 shadow-sm">
            {galleryLoading ? (
                <div className="py-16 text-center text-gray-500">Loading gallery...</div>
            ) : gallery.length ? (
                <>
                    <div className="grid gap-5 sm:grid-cols-2 xl:grid-cols-3">
                        {gallery.map((item, index) => (
                            <div key={item.id || index} className="overflow-hidden rounded-lg border border-gray-200 bg-white">
                                <img src={item.image} alt={item.caption || `Gallery ${index + 1}`} className="h-64 w-full object-cover" />
                                {item.caption && <p className="p-3 text-sm text-gray-600">{item.caption}</p>}
                            </div>
                        ))}
                    </div>
                    <Pagination
                        pageNation={galleryPagination}
                        onPrev={() => fetchHostGalleryData(galleryPagination.prevPage)}
                        onNext={() => fetchHostGalleryData(galleryPagination.nextPage)}
                    />
                </>
            ) : (
                <div className="rounded-lg border border-dashed border-gray-300 px-6 py-16 text-center text-gray-500">
                    No gallery images found for this host.
                </div>
            )}
        </div>
    );

    const renderCurrentTab = () => {
        switch (currentTab) {
            case 'Basic Details':
                return renderBasicDetails();
            case 'Events':
                return renderEvents();
            case 'Reviews':
                return renderReviews();
            case 'Gallery':
                return renderGallery();
            default:
                return null;
        }
    };

    if (loading) {
        return (
            <div className="flex flex-col h-screen">
                <div className="min-h-[120px] w-full">
                    <MainNavbar />
                </div>
                <div className="flex">
                    <div className="w-2/12 h-screen">
                        <MainSidebar />
                    </div>
                    <div className="flex w-10/12 items-center justify-center bg-[#f8f8f8] text-xl text-black">
                        Loading host details...
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="flex flex-col h-screen">
            {eventLink.visibility &&
                <Suspense>
                    <EventLink
                        onClose={() => setEventLink({ visibility: false, evetnId: null, link: null })}
                        text={eventLink.link}
                        onConfirm={(link) => handleUpdateHostEventOnlineLink(eventLink.evetnId, link)}
                    />
                </Suspense>
            }

            {duplicate &&
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75">
                    <div className="flex h-[290px] w-[454px] flex-col items-center justify-center rounded-lg bg-white p-4 text-center shadow-lg">
                        <h2 className="text-lg font-bold">Duplicate Event Confirmation</h2>
                        <p className="mt-2 mb-4 w-[308px] text-gray-500">Add time to highlight what makes it unique Event Time</p>
                        <div className="flex gap-5">
                            <button className="rounded bg-gray-300 px-4 py-2 text-black" onClick={() => {
                                setDuplicate(false);
                                setDuplicateEventId(null);
                            }}>Cancel</button>
                            <button className="mr-2 rounded bg-red-500 px-4 py-2 text-white" onClick={() => duplicateEventApi()}>Confirm</button>
                        </div>
                    </div>
                </div>
            }

            <div className="min-h-[120px] w-full">
                <MainNavbar />
            </div>

            <div className="flex">
                <div className="w-2/12 h-screen">
                    <MainSidebar />
                </div>

                <div className="h-full w-10/12 bg-[#f8f8f8]">
                    <div className="m-10 mb-6 rounded-xl bg-white p-6 shadow-sm">
                        <div className="flex flex-wrap items-center justify-between gap-6">
                            <div className="flex items-center gap-4">
                                <img
                                    src={host?.photo || 'https://via.placeholder.com/200x200?text=Host'}
                                    alt={host?.name || 'Host'}
                                    className="h-20 w-20 rounded-xl object-cover"
                                />
                                <div>
                                    <h1 className="text-2xl font-semibold text-black">{host?.name || 'Host Details'}</h1>
                                    <p className="mt-1 text-sm text-gray-500">{host?.focus || host?.category || 'Event host profile'}</p>
                                </div>
                            </div>

                            <div className="flex flex-wrap gap-3">
                                {topTabs.map((tab) => (
                                    <button
                                        key={tab}
                                        type="button"
                                        onClick={() => setCurrentTab(tab)}
                                        className={`rounded-lg px-5 py-2 text-sm font-semibold ${
                                            currentTab === tab ? 'bg-brandRed text-white' : 'bg-gray-100 text-gray-700'
                                        }`}
                                    >
                                        {tab}
                                    </button>
                                ))}
                            </div>
                        </div>
                    </div>

                    <div className="px-10 pb-10">
                        {renderCurrentTab()}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Index;
